module.exports = __webpack_public_path__ + "img/UTESCA-7.34faaded.jpg";